import React, { useState, useEffect } from 'react';
//import { FormComponent } from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import { searchService, loggedInUserService } from '../services';
import UpcomingAction from './CrmUpcomingAction';
import RefreshFiltersAndPagesButtons from './CrmRefreshingFiltersAndPages';

import './CrmUpcomingActionsStyle.less';

let isScheduled = x => !(x.meetingTime === undefined || x.meetingTime === null);

const CrmUpcomingActionsComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {

  const [refresh, setRefresh] = useState( false );
  const [actions, setActions] = useState([]);
  const [filter, setFilter] = useState( {"filterScheduleType": "all", "filterActionType": "all", filterUser:"currentUser", "showHidden": false, "searchField": "" } );
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(1);
  const onlyTagged = componentDefinition['onlyTagged'] !== undefined ? componentDefinition['onlyTagged'] : true;
  const pageLength = 25;

  let filterOptionMenu = componentDefinition['filterOptionMenu'];
  if (filterOptionMenu === undefined || filterOptionMenu === null)
    filterOptionMenu = [ "scheduleType", "actionType", "user", "showHidden", "showSearch" ];

  //let scheduledActions = scheduled.map( x => <UpcomingAction action={x}/> );
  //let unscheduledActions = unscheduled.map( x => <UpcomingAction action={x}/> );

  let generateQuery = () => {

    let filterQ : any = [
      { "term": { "systemHeader.systemType": "document" } },
      { "term": { "appTags": "crm" } },
      { "term": { "appTags": "actions" } }
    ]
    let should : any = []
    let must : any = []
    let must_not : any = [
      { "term": { "appTags": "history" } },
      { "term": { "status": "Completed" } },
      { "term": { "status": "Cancelled" } }
    ]

    if ( filter['filterScheduleType'] !== 'all' )
      ( filter['filterScheduleType'] === 'unscheduled' ? must_not : must ).push( { "exists": { "field": "meetingTime" } } );

    if ( filter['filterActionType'] !== 'all' )
      filterQ.push( { 'term': { "actionType": filter['filterActionType'] } } )

    if ( filter['filterUser'] !== 'all' )
      filterQ.push( { 'term': { "teamMemberRel.documentId": loggedInUserService.user.account.documentId } } )

    if ( onlyTagged )
    { 
      should.push( { 'term': { "contactsRel.documentId": document.documentId } } )
      should.push( { 'term': { "opportunityRel.documentId": document.documentId } } )
      should.push( { 'term': { "organisationRel.documentId": document.documentId } } )
    }


    if ( filter.searchField.length > 0 )
    {
      let wildcardedFitler = "*" + filter.searchField + "*";
      let should2 = [];
      should2.push( { 'wildcard': { "desc": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "notes": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "contactsRel.name": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "opportunityRel.name": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "organisationRel.name": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "teamMemberRel.name": {"value":wildcardedFitler, "case_insensitive": true } } } )
      should2.push( { 'wildcard': { "tagsRel.name": {"value":wildcardedFitler, "case_insensitive": true } } } )

      must.push( {
        "bool": {
          "should": should2,
          "minimum_should_match": 1
        }
      } )
    }

    if ( filter['showHidden'] === false )
    {
      must.push( {
        "bool": {
          "should": [
            {'range':{'hiddenUntil':{'lt':'now'}}},
            {"bool": {"must_not": {"exists": {"field": "hiddenUntil"}}}}
          ],
          "minimum_should_match": 1
        }
      } )
    }

    return {
      "query": {
        "bool": {
          "filter": filterQ,
          "should": should,
          "must": must,
          "must_not": must_not,
          "minimum_should_match": should.length > 0 ? 1 : 0
        }
      },
      "sort": [ 
        { "pinnedToUpcoming": "desc" },
        { "meetingTime": "asc" },
        { "systemHeader.documentCreatedDate": "asc" }
     ]
    }
  };

  let getData = () => {
    if ( !refresh )
    {
      setRefresh( true );
      let query = generateQuery();

      searchService.search({
        filter: query,
        page: page,
        size: pageLength
      }).then( result => {
        setActions( result.data.hits.hits.map( x => x._source ) );
        console.warn( query, result.data.hits.hits.map( x => x._source )  )
        
        let newMaxPage = Math.ceil(result.data.hits.total / pageLength);
        setMaxPage( newMaxPage <= 0 ? 1 : newMaxPage );
        setRefresh( false );

      } ).catch( e => {console.error(e); setRefresh( false );} );
    }
  }

  useEffect( () => {
    // get initial data
    getData();
  }, [filter, page] )

  useEffect( () => {
    // get initial data
    setPage(0);
  }, [filter] )

  useEffect( () => {
    if ( page < 0 )
      setPage( 0 );

    if ( page >= maxPage )
      setPage( maxPage - 1 );
  }, [page, maxPage]);
  
  /*useEffect( () => {
    setScheduled( actions.filter( isScheduled ) );
    setUnscheduled( actions.filter( x => !isScheduled(x) ) );
  }, [actions] )*/

  let actionElements = actions.map( x => <UpcomingAction action={x} doRefresh={getData} /> );
  
  let devWarning = <div className="alert alert-sm alert-danger">
    <i class="fas fa-exclamation-circle"></i> This Element is experimental
  </div>;

  return (
    <div>
      <div className="panel panel-primary">
        <div className="panel-heading">
          <div className="crm-panel-icon-background">
            <i className="fa fa-phone crm-panel-icon"/>
          </div>
          Upcoming Actions
          <RefreshFiltersAndPagesButtons filterOptionMenu={filterOptionMenu} filter={filter} setFilter={setFilter} doRefresh={ getData } isRefreshing={refresh} page={page} setPage={setPage} maxPage={maxPage} />
        </div>
        <div className="panel-body upcoming-actions-body">
          {
            /*scheduledActions.length == 0 && unscheduledActions.length == 0*/ 
            actionElements.length === 0 ? 
              (
                <div className="alert alert-info">
                  <i class="fas fa-exclamation-circle"></i> No Actions Found
                </div>
              ) : 
              <div/>
          }
          {actionElements}
        </div>
      </div>
    </div>
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('crm-upcoming-actions', CrmUpcomingActionsComponent);

export default CrmUpcomingActionsComponent;
